module.exports = __webpack_public_path__ + "static/assets/64e4a905e7c3ab32ef03272631c3df75.png";